import { useEffect, useState } from 'react';
import { _single } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    _value: any;
    onChange: (value: any | null) => void; // Permite valores null
    readonly?: boolean;
    _label?: string;
    _locale?: string;
    _currency?: string;
    _minFracDig?: number;
    _maxFracDig?: number;
    useDevPropertie?: boolean;
    _style?: "currency" | "decimal";
}

export const InputMoney = ({ _value, onChange, readonly, _label, useDevPropertie, _currency, _locale, _maxFracDig, _minFracDig, _style = "currency" }: Props) => {
    const [value, setValue] = useState<string>("0");
    const [locale, setLocale] = useState<string>("en-US");
    const [currency, setCurrency] = useState<string>("USD");
    const [minFracDig, setMinFracDig] = useState<number>(2);
    const [maxFracDig, setMaxFracDig] = useState<number>(2);

    useEffect(() => {
        if (useDevPropertie) {
            if (_locale) setLocale(_locale);
            if (_currency) setCurrency(_currency);
            if (_minFracDig) setMinFracDig(_minFracDig);
            if (_maxFracDig) setMaxFracDig(_maxFracDig);
        } else {
            const properties = _single.getMoneyFormater();
            if (properties.Locale) setLocale(properties.Locale);
            if (properties.Currency) setCurrency(properties.Currency);
            if (properties.Min) setMinFracDig(properties.Min);
            if (properties.Max) setMaxFracDig(properties.Max);
        }
    }, [useDevPropertie]);

    useEffect(() => {
        const numericValue = parseValue(value);
        if (_value !== numericValue) {
            const formattedValue = formatValue(_value);
            setValue(formattedValue);
        }
    }, [_value]);

    const formatValue = (number: any): string => {
        if (isNaN(number)) return "";
        return new Intl.NumberFormat(locale, {
            style: _style,
            currency: currency || undefined,
            minimumFractionDigits: minFracDig,
            maximumFractionDigits: maxFracDig,
        }).format(number);
    };

    const parseValue = (formattedValue: string): number => {
        const numericValue = parseFloat(
            formattedValue.replace(/[^0-9.-]+/g, "") || "0"
        );
        return Number(numericValue.toFixed(Math.max(minFracDig, maxFracDig)));
    };

    return (
        <>
            <label>{_label ?? "Valor"}</label>
            <input
                readOnly={readonly}
                type="text"
                className="form-control"
                value={value}
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                onChange={(e) => {
                    const rawValue = e.target.value;
                    setValue(rawValue);
                }}
                onBlur={() => {
                    const numericValue = parseValue(value);
                    if (!value.trim()) {
                        setValue("");
                        onChange(null);
                    } else {
                        const formattedValue = formatValue(numericValue);
                        setValue(formattedValue);
                        onChange(numericValue);
                    }
                }}
            />
        </>
    );
};
